/**
 * Transform branch
 * @param {Array} input branch
 * @returns {Array} branch
 */
export const transformBranch = (input = {}) => {
	return {
		id: input.id || null,
		itecBranchId: input.itec_id || null,
		nameTH: input.name_th || null,
		nameEN: input.name_en || null,
	};
};

/**
 * Transform branches
 * @param {Array} input branches
 * @returns {Array} branches
 */
export const transformBranches = (input = []) => {
	return input.map((item) => transformBranch(item));
};